export const strToFloat = (str: string): number => {
  return (parseFloat((str || '').replace(',', '.')) || 0);
};
